import {
    Component,
    OnInit,
    Input,
    OnDestroy,
    ViewChild,
    ElementRef,
    Inject,
    PLATFORM_ID,
} from '@angular/core';
import { CommonButton } from '../button/button.component';
import {
    PartnersServiceService,
    ListiquePartnerServiceEntityVisual,
    ListiquePartnerServiceEntity,
} from '@listique/api';
import { Subject, Observable } from 'rxjs';
import { takeUntil, startWith, map, take } from 'rxjs/operators';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';

export const _filter = (
    opt: ListiquePartnerServiceEntity[],
    value: string,
): ListiquePartnerServiceEntity[] => {
    const filterValue = value.toLowerCase();
    return opt.filter(
        item => item.title.toLowerCase().indexOf(filterValue) >= 0,
    );
};

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit, OnDestroy {
    @Input() button?: CommonButton = {
        title: 'Search',
        icon: 'search',
        iconType: 'svg',
        type: 'button',
    };
    @Input() placeholder?: string = 'What can we help you with?';
    services: ListiquePartnerServiceEntityVisual[];
    servicesLoaded = false;
    @Input() micro: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject();

    searchForm: FormGroup = this._formBuilder.group({
        servicePicker: '',
    });

    serviceGroupOptions: Observable<ListiquePartnerServiceEntityVisual[]>;
    fullTextSearchMode = environment.env === 'prod' ? true : false;
    constructor(
        private partnersServiceService: PartnersServiceService,
        private _formBuilder: FormBuilder,
        private router: Router,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        /*if (isPlatformBrowser(this.platformId)) {
            this.fullTextSearchMode = localStorage.getItem('fullTextSearchMode') === 'true' ? true : false;
        }*/
        if (this.fullTextSearchMode === false) {
            this.partnersServiceService
                .list()
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(result => {
                    this.services = result;
                    this.servicesLoaded = true;
                    this.serviceGroupOptions = this.searchForm
                        .get('servicePicker')!
                        .valueChanges.pipe(
                            startWith(''),
                            map(value => this._filterGroup(value)),
                        );
                });
        }
    }

    ngOnInit() { }

    private _filterGroup(value: string): ListiquePartnerServiceEntityVisual[] {
        if (value) {
            return this.services
                .map(
                    group =>
                        ({
                            ...group,
                            childServices: _filter(group.childServices, value),
                        } as any),
                )
                .filter(group => group.childServices.length > 0);
        }

        return this.services;
    }

    ngOnDestroy() {
        this._unsubscribeAll.unsubscribe();
    }

    pickService(
        service: ListiquePartnerServiceEntityVisual,
        childService: ListiquePartnerServiceEntity,
    ) {
        if (childService === null) {
            this.router.navigate([`/categories/${service.slug}`]);
        } else {
            this.router.navigate([`/categories/${service.slug}`], {
                queryParams: { filter: childService.slug },
            });
        }
        this.searchForm.get('servicePicker').setValue(null);
    }

    enterKeyCheck() {
        /*if (this.searchForm.get('servicePicker').value === 'fulltextsearchon') {
            localStorage.setItem('fullTextSearchMode', 'true')
        } else if (this.searchForm.get('servicePicker').value === 'fulltextsearchoff') {
            localStorage.setItem('fullTextSearchMode', 'false')
        }*/

        if (this.fullTextSearchMode === true) {
            this.router.navigate([`/partners/search`], { queryParams: { query: this.searchForm.get('servicePicker').value } })
        } else if (this.fullTextSearchMode === false) {
            const options = this._filterGroup(this.searchForm.get('servicePicker').value);
            if (options.length === 1 && options[0].childServices.length === 1) {
                this.pickService(options[0], options[0].childServices[0]);
            }
        }
    }
}
